import Echo from "laravel-echo"
window.io = require('socket.io-client');

let echo = new Echo({
    broadcaster: 'socket.io',
    host: window.location.hostname,
    forceTLS: true
});

if (window.location.pathname.indexOf('/bitcoin/payment') === 0) {
    const paymentId = window.location.pathname.split('payment/')[1]
    echo.private(`bitcoin.payment.${paymentId}`)
        .listen('.payment.changed', (e) => {
            console.log('payment updated')
            setTimeout(function () {
                window.location = window.location
            }, 1000) // wait apply time
        });
}
